<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1F4PCm/tc-custom/9780253052322.jpg?1713470915960" alt="This image is the cover for the book Shaken and the Stirred, The Year's Work"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shaken and the Stirred, The Year's Work
      </h1>
      <p class="bookDescription body article font2">
        <p>Over the past decade, the popularity of cocktails has returned with gusto. Amateur and professional mixologists alike have set about recovering not just the craft of the cocktail, but also its history, philosophy, and culture. <i>The Shaken and the Stirred</i> features essays written by distillers, bartenders and amateur mixologists, as well as scholars, all examining the so-called 'Cocktail Revival' and cocktail culture. Why has the cocktail returned with such force? Why has the cocktail always acted as a cultural indicator of class, race, sexuality and politics in both the real and the fictional world? Why has the cocktail revival produced a host of professional organizations, blogs, and conferences devoted to examining and reviving both the drinks and habits of these earlier cultures?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Schneider, Craig N. Owens
      </h2>
      
      <p class="authorDescription body article"><P>Stephen Schneider is Associate Professor of English at the University of Louisville. He is the author of <I>You Can't Padlock an Idea.</P><P></I>Craig N. Owens is Professor of English at Drake University. He is the editor of <I>Pinter Et Cetera.</I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f7b12aa